import { FormValues } from "@features/builder/graph/contextMenu/RenameDialog/schema"
import { AppNode } from "@features/builder/graph/types"
import { createLagNodeLabel } from "@utils/node"

export function oldToNewLabelMap(
  data: FormValues,
  oldToNewIdMap: Map<string, string>,
  getNode: (id: string) => AppNode | undefined,
) {
  const newIdToNewlabelMap = new Map<string, string>()
  for (const item of data.labels) {
    if (item.lagValue !== undefined) {
      const lagLabel = createLagNodeLabel(item.label, item.lagValue)
      newIdToNewlabelMap.set(item.id, lagLabel)
    } else {
      newIdToNewlabelMap.set(item.id, item.label)
    }
  }

  const oldToNewLabelMap = new Map<string, string>()
  for (const [oldId, newId] of oldToNewIdMap) {
    oldToNewLabelMap.set(
      getNode(oldId)?.data.label ?? oldId,
      newIdToNewlabelMap.get(getNode(newId)?.data.label ?? newId) ?? newId,
    )
  }

  return oldToNewLabelMap
}
